// extracted by mini-css-extract-plugin
export default {"button":"Button_button__JBBzO","disabled":"Button_disabled__DkgJ+","redButton":"Button_redButton__Ln1mb","tabButton":"Button_tabButton__VEVu+","isActive":"Button_isActive__HDJxY"};